// import subAPI from '@/api/init';
import {
  DEFAULT_DATE,
  PAYMENT_TYPES,
  CREDITCARD_PAYMENT_TYPE_VALUE,
  EWAY_RECURRING_PAYMENT,
} from '@/common/constants';
import { useAppStore } from '@/store/app';
import { format } from 'date-fns';

/**
 * @description Check if value is empty
 * @param {*} value - Whatever you want.
 * @return {boolean}
 */
export const isEmpty = (value) =>
  value === undefined ||
  value === null ||
  (typeof value === 'object' && Object.keys(value).length === 0) ||
  (typeof value === 'string' && value.trim().length === 0) ||
  (Object.entries(value).length === 0 && value.constructor === Object);

/**
 * @description Set default authorization header
 * @param {string} token - Bear Token (JWT)
 */
export const setAuthToken = (token) => {
  if (token) {
    // subAPI.defaults.headers['Authorization'] = token;
  } else {
    // delete subAPI.defaults.headers['Authorization'];
  }
};

/**
 * @description Set default authorization header
 * @param {Object} rawObj - Original object
 * @param {Array.<String>} allowed - Array of strings containing proptery key whitelisted
 */
export const whiteListedKeys = ({ rawObj, allowed }) => {
  const filtered = Object.keys(rawObj)
    .filter((key) => allowed.includes(key))
    .reduce((obj, key) => {
      obj[key] = rawObj[key];
      return obj;
    }, {});

  return filtered;
};

/**
 * @description Return shsorted date
 * @param {Object} date - new Date instance long form.
 * @param {String}
 */
export const returndate = ({ date }) => {
  if (date === DEFAULT_DATE || isEmpty(date)) return 'N/A';

  // Handle date parsing more carefully to avoid timezone issues
  // For ISO date strings (e.g., "2024-01-15T00:00:00Z" or "2024-01-15T00:00:00"),
  // extract just the date part (YYYY-MM-DD) to avoid timezone shifts
  let dateObj;
  if (date instanceof Date) {
    dateObj = date;
  } else if (typeof date === 'string') {
    // Check if it's an ISO date string (contains 'T')
    if (date.includes('T')) {
      // Extract date part (YYYY-MM-DD) before the 'T'
      const datePart = date.split('T')[0];
      // Parse YYYY-MM-DD format which is timezone-safe
      const [year, month, day] = datePart.split('-').map(Number);
      dateObj = new Date(year, month - 1, day); // month is 0-indexed
    } else {
      // For other string formats, parse normally
      dateObj = new Date(date);
    }
  } else {
    dateObj = new Date(date);
  }

  // Format using date-fns, ensuring we use the date part only (no time)
  return format(dateObj, 'dd/MM/yyyy');
};

export const getPaymentTypeDisplay = (paymentType) => {
  const paymentTypeObj = PAYMENT_TYPES.find((item) => item.value === paymentType);
  return paymentTypeObj ? paymentTypeObj.label : 'Unknown';
};

/**
 * Cancel Subscription
 */
export const onToggleSubscription = async (subscription) => {
  const store = useAppStore();
  const message = `Are you sure you want to ${
    subscription.status ? 'cancel' : 'enable'
  } the subscription for ${subscription?.firstName} ${subscription?.lastName}`;
  const isDelete = confirm(message);
  if (isDelete) {
    const subscriptionId = subscription?.id ?? subscription?.subscriptionId;

    // credit card + recurring means eway involved, if canceling, need backend to cancel eway subscription
    if (
      subscription.paymentType === CREDITCARD_PAYMENT_TYPE_VALUE &&
      subscription.subscriptionTypeName === EWAY_RECURRING_PAYMENT &&
      subscription.status
    ) {
      return await store.cancelSubscription({ subscriptionId });
    } else {
      subscription.status = subscription.status ? 0 : 1;
      return await store.updateSubscription(subscription);
    }
  }
};

export const enableUser = async (subscription) => {
  const username = subscription?.username;
  const store = useAppStore();
  return await store.enableUser(username);
};

export const disableUser = async (subscription) => {
  const username = subscription?.username;
  const store = useAppStore();
  return await store.disableUser(username);
};
